import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter,withViewTransitions, withRouterConfig, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authTokenInterceptor } from './interceptors/auth-token.interceptor';
import { provideToastr } from 'ngx-toastr'; // Import ToastrModule
import { provideAnimations } from '@angular/platform-browser/animations'; // Import BrowserAnimationsModule
import { NgxSpinnerModule } from 'ngx-spinner'; // Import NgxSpinnerModule
import { spinnerInterceptor } from './interceptors/spinner.interceptor';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { provideAuth, getAuth } from '@angular/fire/auth'; // Import for Auth service
import { environment } from '../environments/environment';
import { definePreset } from '@primeng/themes';
import { provideStore } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects';
import { DatePipe } from '@angular/common';
import { TaxTypeEffect } from './after-login/store/tax/tax.effect';
import { taxTypeReducer } from './after-login/store/tax/tax.reducer';

import { provideTranslateService, TranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { LanguageInterceptor } from './interceptors/language.interceptor';
// import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { credentialsInterceptor } from './interceptors/credentials.interceptor';
import { provideServiceWorker } from '@angular/service-worker';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f0eefd',
      100: '#dddaf9',
      200: '#b4b0ef',
      300: '#867fdf',
      400: '#5f53c8',
      500: '#080032',
      600: '#06002b',
      700: '#050024',
      800: '#04001d',
      900: '#030017',
      950: '#01000c'
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // provideRouter(routes),
    provideRouter(
      routes,
      // withPreloading(PreloadAllModules),
      withViewTransitions(),
      withComponentInputBinding(),
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    provideHttpClient(
      withInterceptors([credentialsInterceptor, authTokenInterceptor, spinnerInterceptor, LanguageInterceptor]) // Register the interceptor here
    ),
    provideAnimations(),

    provideToastr({ preventDuplicates: true }),
    // provideHttpClient(
    //   withInterceptors([decryptInterceptor])
    // ),
    // provideStore(),
    provideStore({ taxType: taxTypeReducer }),
    provideEffects([TaxTypeEffect]),
    // NgxSpinnerModule,
    importProvidersFrom(NgxSpinnerModule),
    // importProvidersFrom(NgxMaterialTimepickerModule.setOpts('en-US', 'latn')),
    // importProvidersFrom(NgxMaterialTimepickerModule.setOpts('ar-AE', 'arab')), open below if am/pm need convert

    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.my-app-dark',
        },
      },
    }),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    }),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),

    provideMessaging(() => getMessaging()),
    provideAuth(() => getAuth()),
    DatePipe, provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
};
